import classNames from 'classnames'
import Link from 'next/link'
import { memo, useRef } from 'react'
import DropdownItem from 'react-bootstrap/DropdownItem'
import { Menu, Typeahead as BSTypeahead } from 'react-bootstrap-typeahead'

import { TagLinkType } from '@/types/page'
import useDirectories from '@/utils/useDirectories'

import styles from './TagsTypeahead.module.scss'

type Props = {
  bracket?: string
  budget?: string
  colorId?: string
  sanitized: string
  tags: TagLinkType[]
}

const TagsTypeahead = ({ bracket, budget, colorId, sanitized, tags }: Props) => {
  const { dir } = useDirectories()

  const ref = useRef<BSTypeahead<any>>(null)

  return (
    <BSTypeahead
      className={classNames(styles.typeahead, 'mt-2')}
      id='more-tags'
      options={tags.map((tags) => ({ ...tags, label: tags.value }))}
      placeholder='More Tags...'
      ref={ref}
      renderMenu={(tags, menuProps) => (
        <Menu {...menuProps}>
          {tags.map((tag) => {
            const count = budget ? Math.floor(tag.count / 10) : tag.count
            if (count === 0) return null

            return (
              <DropdownItem
                as={Link}
                href={`/${dir}/${sanitized}${colorId ? `/${colorId}` : ''}${bracket ? `/${bracket}` : ''}/${tag['slug']}${budget ? `/${budget}` : ''}`}
                key={tag.value}
                onClick={() => ref.current?.clear()}
                scroll={false}
              >
                <div className={styles.item}>
                  <span className='me-4'>{tag.value}</span>
                  <span>{count}</span>
                </div>
              </DropdownItem>
            )
          })}
        </Menu>
      )}
    />
  )
}

export default memo(TagsTypeahead)
